import { useEffect, useState } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import { toast } from 'react-toastify';
import { _DOCDocumentType } from '../../../../core/services/dataBean/EntityCatalog';
import { Modal } from '../../../theme/Component/Modal';
import { DOCDocumentType } from './DOCDocumentType';

interface Props {
    label?: string;
    idSelector: number;
    onChange: (value: any) => void;
    disabled?: boolean;
}

export const EditorDOCDocumentType = ({ idSelector, label, onChange, disabled }: Props) => {
    const { instance } = useDataBean(_DOCDocumentType);

    const modal = useModal("Catálogo de Tipos Documentales", MODAL_LG);

    const [valor, setValor] = useState('');
    const [obj, setObj] = useState<any>({});

    const getProperties = (item: any) => {
        return item?.DataBeanProperties ?? item ?? {};
    };

    const getDisplayValue = (item: any) => {
        const data = getProperties(item);

        if (!data?.Code && !data?.Name) {
            return '';
        }

        return `${data.Code ?? ''} - ${data.Name ?? ''}`;
    };

    useEffect(() => {
        if (idSelector) {
            getProduct();
        } else {
            setValor('');
            setObj({});
        }
    }, [idSelector]);

    const getProduct = () => {
        instance.getDOCDocumentType(idSelector).then((resp: any) => {
            console.log("Tipo documental encontrado:", resp);
            setObj(resp);
            setValor(getDisplayValue(resp));
            onChange(resp);
        }).catch(() => {
            toast.error("Tipo Documental no encontrado");
            setValor('');
            setObj({});
        });
    };

    const returnValue = () => {
        const data = getProperties(obj);

        if (data?.IDDOCDocumentType) {
            setValor(getDisplayValue(obj));
            modal.close();
            onChange(obj);
        } else {
            toast.error("Tipo Documental no válido");
        }
    };

    return (
        <>
            {label && label !== " " && (
                <label>{label ?? "Seleccione un Tipo Documental"}</label>
            )}

            <div
                className={`form-control text-wrap ${disabled ? 'bg-light text-muted' : 'cursor-pointer'}`}
                style={{ minHeight: '35px' }}
                onClick={() => {
                    if (!disabled) {
                        modal.open();
                    }
                }}
            >
                {valor ? valor : <span>Seleccionar...</span>}
            </div>

            <Modal
                onSubmitLabel="Seleccionar"
                modal={modal.modal}
                updateModal={modal.setModal}
                eventModal={returnValue}
            >
                <DOCDocumentType
                    isModal
                    _onChange={(e: any) => {
                        setObj(e);
                    }}
                />
            </Modal>
        </>
    );
};